import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PropertiesMap from './properties_map';
import { selectPropertyMarker, hideMapInfoBubble, toggleMapList } from "../store/actions/ui";
import { toggleSelectProperty } from '../store/actions/select_list';

export class PropertiesMapContainer extends React.Component {
  static propTypes = {
    activeProperty: PropTypes.object,
    googleMapsApiKey: PropTypes.string.isRequired,
    initialFetchComplete: PropTypes.bool.isRequired,
    mapMarkerPath: PropTypes.string.isRequired,
    markerAnchor: PropTypes.array.isRequired,
    markerClustererStyles: PropTypes.array.isRequired,
    properties: PropTypes.array.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    showInfoWindow: PropTypes.bool.isRequired,
    showMapList: PropTypes.bool.isRequired,
    toggleMapList: PropTypes.func.isRequired,
    toggleSelectProperty: PropTypes.func.isRequired,
    onHideMapInfoBubble: PropTypes.func.isRequired,
    onSelectProperty: PropTypes.func.isRequired
  };

  mappableProperties = () => this.props.properties.filter((property) => {
    return property.latitude && property.longitude &&
      (property.latitude !== 0 && property.longitude !== 0);
  });

  render() {
    const {
      activeProperty,
      googleMapsApiKey,
      initialFetchComplete,
      mapMarkerPath,
      markerAnchor,
      markerClustererStyles,
      selectedPropertyIds,
      showInfoWindow,
      showMapList,
      toggleMapList,
      toggleSelectProperty,

      onHideMapInfoBubble,
      onSelectProperty,
    } = this.props;

    return (
      <PropertiesMap
        activeProperty={activeProperty}
        googleMapsApiKey={googleMapsApiKey}
        initialFetchComplete={initialFetchComplete}
        mapMarkerPath={mapMarkerPath}
        markerAnchor={markerAnchor}
        markerClustererStyles={markerClustererStyles}
        overlay={!initialFetchComplete}
        properties={this.mappableProperties()}
        selectedPropertyIds={selectedPropertyIds}
        showInfoWindow={showInfoWindow}
        showMapList={showMapList}
        toggleMapList={toggleMapList}
        toggleSelectProperty={toggleSelectProperty}
        onHideMapInfoBubble={onHideMapInfoBubble}
        onSelectProperty={onSelectProperty}
      />
    );
  }
}

const mapStateToProps = state => ({
  activeProperty: state.ui.activeMapProperty,
  googleMapsApiKey: state.ui.googleMapsApiKey,
  initialFetchComplete: state.search.initialFetchComplete,
  isFetching: state.search.isFetching,
  mapMarkerPath: state.paths.mapMarker,
  markerAnchor: state.ui.markerAnchor,
  markerClustererStyles: state.ui.markerClustererStyles,
  properties: state.search.meta.mapLocations,
  selectedPropertyIds: state.selectList.selectedPropertyIds,
  showInfoWindow: state.ui.showMapInfoWindow,
  showMapList: state.ui.showMapList
});

const mapDispatchToProps = {
  toggleSelectProperty,
  toggleMapList,

  onSelectProperty: selectPropertyMarker,
  onHideMapInfoBubble: hideMapInfoBubble
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesMapContainer);
